import { CommonUtil } from "utils/CommonUtil";

export enum MsgraphPermissionType{
    MicrosoftOneDrive,
    MicrosoftSharepoint,
}

export interface IPermission{
    id: string;
    displayName: string;
    isRequired: boolean;
    note: string;
}


export class PermissionBase<T> implements IPermission {
    public id: string;
    public displayName: string;
    public isRequired: boolean;
    public note: string;
}

export class MsgraphPermission extends PermissionBase<MsgraphPermissionType>{
    constructor(type: MsgraphPermissionType, isRequired: boolean){
        super();
        this.id = type.toString();
        this.isRequired = isRequired;
        const isOneDriveType = type === MsgraphPermissionType.MicrosoftOneDrive;
        this.displayName = isOneDriveType ? "Microsoft OneDrive" :  "Microsoft Sharepoint";   
        this.note = isOneDriveType ? null : "Admin privileges often required"
    }

    public static hasPermission(type: MsgraphPermissionType, permissionIds: string[]){
        return permissionIds.some(id => {
            const t =  CommonUtil.tryParseEnum(MsgraphPermissionType, id);
            return t === type;
        });
    }
}